module.exports = __webpack_public_path__ + "img/9788952745170.5c09b17e.jpg";